import {Component, inject} from '@angular/core';
import {Location, NgClass} from "@angular/common";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {FormsModule} from "@angular/forms";
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {Router} from '@angular/router';

@Component({
  selector: 'app-add-device',
  imports: [
    GenericButtonComponent,
    NgClass,
    FormsModule
],
  templateUrl: './add-device.component.html',
  styleUrl: './add-device.component.css'
})
export class AddDeviceComponent {

  private location = inject(Location);
  private mainViewStore = inject(MainViewStore);
  private router = inject(Router);

  constructor(
    protected viewportService: ViewportService
  ) {}

  back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }

  addProximitySamplePoint() {
    this.router.navigate(['/main/add-proximity-sample-point'])
  }

  addLoRaGateway() {
    this.router.navigate(['/main/add-gateway'])
  }

  addWaterPoint() {
    this.router.navigate(['/main/add-water-point'])
  }
}
